import React from "react";
const NewsItemSkeleton = ({ id }) => {
  return (
    <div
      className="border rounded-4 px-3 py-2 mb-2"
      id={id}
      style={{
        background: "#FFFFFF",
        borderColor: "#E5EAF1",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)",
      }}
    >
      <div className="d-flex flex-column gap-2">
        <div className="d-flex justify-content-between align-items-start gap-3">
          <div
            className="shimmer"
            style={{ height: "18px", width: "82%" }}
          ></div>
          <div
            className="shimmer rounded"
            style={{ height: "22px", width: "22px" }}
          ></div>
        </div>
        <div
          className="d-flex align-items-center gap-2 flex-wrap"
        >
          <div
            className="shimmer rounded-pill"
            style={{ height: "24px", width: "124px" }}
          ></div>
          <div
            className="shimmer"
            style={{ height: "12px", width: "72px" }}
          ></div>
          <div
            className="shimmer rounded-pill"
            style={{ height: "24px", width: "72px" }}
          ></div>
          <div
            className="shimmer rounded-pill"
            style={{ height: "24px", width: "96px" }}
          ></div>
        </div>
        <div
          className="shimmer"
          style={{ height: "14px", width: "96%" }}
        ></div>
        <div
          className="shimmer"
          style={{ height: "14px", width: "78%" }}
        ></div>
      </div>
    </div>
  );
};

export default NewsItemSkeleton;
